export default __webpack_public_path__ + "static/media/branched_value.9910c680.svg";